// extracted by mini-css-extract-plugin
export default {"loader":"loader_component_loader__8D70h"};